import {mapGetters, mapActions, mapMutations} from 'vuex';
import Header from '@/components/header/index.vue'
import leftBar from '@/components/left-bar/index.vue'
import TableOptions from '@/components/table/options/index.vue'
import Table from '@/components/table/list/index.vue'
import popupManufacturer from '@/components/popups/catalog/manufacturer/index.vue'
import pagination from '@/components/pagination/index.vue'
import paginationMixin from '@/mixins/pagination/index.js'

export default {
    components:{
        Header,
        leftBar,
        TableOptions,
        Table,
        popupManufacturer,
        pagination
    },
    mixins: [paginationMixin],
    data(){
        return{
            // Статичні визначення полів: перекладні підписи — labelKey,
            // сам `label` обчислюється в computed fields (залежить від локалі).
            fieldDefs:[
                {
                    key: 'id',
                    label: 'ID'
                },
                {
                    key:'title',
                    labelKey:'catalogDict.title',
                },
                {
                    key:'status',
                    labelKey:'catalogDict.status',
                },
                {
                    key:'sort',
                    labelKey:'catalogDict.sort',
                },
            ],
            items:[],
            selectedItem: null,
            showManufacturerPopup: null,
        }
    },
    computed:{
        fields() {
            return this.fieldDefs.map(field => field.labelKey
                ? { ...field, label: this.$t(field.labelKey) }
                : field);
        },
        ...mapGetters({
            menuHide:'config/menuHide',
            manufacturers:'catalog/manufacturers',
        })
    },
    watch:{
        manufacturers(e){
            this.items = []
            e.data.map(item=>{
                this.items.push({id:item.id, 'title': item.title, 'status': Boolean(item.status), 'sort': item.sort})
            })
            this.res = e
        },
        page(e) {
            this.getManufacturers({page: e, per_page: this.per_page});
        },
        per_page(e) {
            this.getManufacturers({page: this.page, per_page: e});
        }
    },
    created() {
        this.toggleLoadingStatus(true);
        this.getManufacturers({page: 1, per_page: this.per_page}).then(()=>{
            this.toggleLoadingStatus(false);
        })
    },
    methods:{
        getSearchInfo(data){
            if(this.activeStatus !== 0){
                if(data.query){
                    this.getManufacturers({[data.type]: data.query,page: this.page, per_page: this.per_page, customer_group_id: this.activeStatus});
                }else{
                    this.getManufacturers({page: this.page, per_page: this.per_page, customer_group_id: this.activeStatus});
                }
            }else{
                if(data.query){
                    this.getManufacturers({[data.type]: data.query,page: this.page, per_page: this.perPage});
                }else{
                    this.getManufacturers({page: this.page, perpage: this.perPage});
                }
            }
        },
        getAllItemsInTable(){
            this.selectedItem = this.items;
            this.$refs.tableComponent.getAllItemsInTable();
        },
        sendManufacturer(item){
            this.addManufacturer(item).then(res=>{
                if(res.status){
                    this.items = [];
                    this.$toasted.success(this.$t('toasts.manufacturer_deleted'), {
                        duration: 3000
                    });
                    this.showManufacturerPopup = false;
                    this.getManufacturers();
                }
            });
        },
        changeManufacturer(item){
            this.editManufacturer(item).then(res=>{
                if(res.status){
                    this.items = [];
                    this.$toasted.success(this.$t('toasts.manufacturer_updated'), {
                        duration: 3000
                    });
                    this.showManufacturerPopup = false;
                    this.getManufacturers();
                }
            });
        },
        selectItem(item){
            if(item.length){
                this.selectedItem = item;
            }else{
                this.selectedItem = null;
            }
        },
        toggleStatus(item){
            const payload = {
                id: item.id,
                data:{
                    title:item.title,
                    status:item.status
                }
            }
            this.editManufacturer(payload)
        },
        editClickManufacturer(item){
            this.showManufacturer(item.id)
            this.showManufacturerPopup = true;
        },
        removeItem(id){
            this.removeManufacturer(id).then(res=>{
                if(res.status){
                    this.items = [];
                    this.getManufacturers();
                    this.$toasted.success(this.$t('toasts.manufacturer_deleted'),{
                        duration : 3000
                    });
                    this.showManufacturerPopup = false;
                }
            })
        },
        ...mapActions({
            getManufacturers:'catalog/getManufacturers',
            showManufacturer:'catalog/showManufacturer',
            editManufacturer:'catalog/editManufacturer',
            addManufacturer:'catalog/addManufacturer',
            removeManufacturer:'catalog/removeManufacturer',
        }),
        ...mapMutations({
            toggleLoadingStatus: 'config/toggleLoadingStatus',
        })
    }
}
